import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=4b48fd07&scoped=true&"
import script from "./Views.vue?vue&type=script&lang=js&"
export * from "./Views.vue?vue&type=script&lang=js&"
import style0 from "./Views.vue?vue&type=style&index=0&id=4b48fd07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48fd07",
  null
  
)

export default component.exports